import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {BasicButton} from 'js/components/button';
import {AppStore, AggregateStore} from 'js/stores'; // singleton stores
import Modal from 'js/components/modal';
import {BASE_URL, META_SCREENS, MESSAGE, LABEL} from 'js/constants';
import _HomeStore from 'js/stores/home';
import List from './list';
import styles from 'css/screens/home.css';

@observer
/**
 * Home screen
 */
export default class Home extends Component {
  /**
   * constructor
   */
  constructor() {
    super();

    this.HomeStore = new _HomeStore();
    this.aggregate = this.aggregate.bind(this);
    this.eventModalClose = this.eventModalClose.bind(this);
  }

  /**
   * did mount
   */
  componentDidMount() {
    AppStore.pageView(META_SCREENS.home);

    // ユーザーの行動判定クリア
    AppStore.updateStep('aggregate', false);
    AppStore.updateStep('regist', false);
  }

  /**
   * will unmount
   */
  componentWillUnmount() {
    AppStore.pageLoading();
  }

  /**
   * modal close event
   */
  eventModalClose() {
    this.HomeStore.clearState();
  }

  /**
   * aggregate
   */
  aggregate() {
    // 集計用storeにセット
    AggregateStore.init({
      categorys: AppStore.selectAllCategorys,
      questions: AppStore.selectAllQuestions,
      phase: AppStore.selectAllPhase,
    });

    // 全ての質問に答えているか
    if (!AggregateStore.check()) {
      this.HomeStore.changeCheckState(true);
      return;
    }

    // 集計
    AggregateStore.start();

    // 集計済みフラグを更新
    AppStore.updateStep('aggregate', true);

    // ページ遷移
    this.props.history.push(`${BASE_URL}/result`);
  }

  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    return (
      <section>
        <div className={styles.block}>
          <h1 className={styles.title}>
            <div>
              {'web' == AppStore.selectAppType && (
                <span>3分でできる</span>
              )}
            </div>
            <div>市場創造PR力診断{LABEL.appType}</div>
            <div>
              {'visit' == AppStore.selectAppType && (
                <span>所要時間：5～10分</span>
              )}
            </div>
          </h1>
          <div className={styles.note}>
            {'web' == AppStore.selectAppType ? (
              <span>
                市場縮小や価格競争の激化といった環境下で求められるのは「市場創造のPR」です。
                既存市場の競争軸を変え、新カテゴリを創出し、新たな習慣を根付かせるPRが必要です。
                当社が長年蓄積してきた知見をもとに市場創造に必要なPR力を診断いたします。
                約3分で終わる20問の質問にご回答いただき「診断結果を見る」をクリックしてください。
                無料お試し診断の結果が表示されます。
              </span>
            ) : (
              <span>
                市場縮小や価格競争の激化といった環境下で求められるのは「市場創造のPR」です。
                既存市場の競争軸を変え、新カテゴリを創出し、新たな習慣を根付かせるPRが必要です。
                当社が長年蓄積してきた知見をもとに市場創造に必要なPR力を診断いたします。
                所要時間5～10分の、40問の質問にご回答いただき、「診断結果を見る」をクリックしてください。
                結果が表示されます。
              </span>
            )}
          </div>
        </div>
        <List />
        <div className={`${styles.block} ${styles.button}`}>
          <BasicButton onClick={this.aggregate}>
            診断結果を見る
          </BasicButton>
        </div>
        {this.HomeStore.check && (
          <Modal close={this.eventModalClose}>
            {MESSAGE.home.check}
          </Modal>
        )}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/screens/home/index.js